import { withFallback } from './helpers/withFallback'

const defaultAuthStore = {
  bootstrapped: true,
  can: () => false,
  canAll: () => false,
  canAny: () => false,
  logout: async () => {},
  user: null,
}

const authState = {
  adapter: defaultAuthStore,
}

export function setXappCoreAuthAdapter(adapter) {
  authState.adapter = withFallback(adapter, defaultAuthStore)
}

export function useXappCoreAuthAdapter() {
  return authState.adapter
}
